unit ClaimScopedList;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.StdCtrls,
  BaseList;

type
  /// <summary>
  /// Other-claims lists opened from a Gift Aid claim. Not used by generic BaseList pages.
  /// </summary>
  TClaimScopedListForm = class(TBaseListForm)
  private
    procedure ClaimViewCloseClick(Sender: TObject);
  protected
    FClaimId: Integer;
    FTaxYear: Integer;
    FClaimStatus: string;
    function CombineFilter(const AFilter: string): string;
    procedure UnLockControls(const AUnLock: Boolean); override;
  public
    procedure SetClaimContext(AClaimId, ATaxYear: Integer;
      const AClaimStatus: string = ''); virtual;
    procedure ApplyClaimContextUI; virtual;
  end;

implementation

uses
  GA.Web.Utils;

procedure TClaimScopedListForm.UnLockControls(const AUnLock: Boolean);
begin
  inherited;
  if FClaimId > 0 then
    AddButton.Enabled := AUnLock;
end;

function TClaimScopedListForm.CombineFilter(const AFilter: string): string;
var
  lClaimFilter: string;
begin
  lClaimFilter := '';
  if FClaimId > 0 then
  begin
    lClaimFilter := Format('ClaimId eq %d and %s',
      [FClaimId, TDonationUIUtils.ClaimScopedStatusODataFilter(FClaimStatus)]);
    if FTaxYear > 0 then
      lClaimFilter := lClaimFilter + Format(' and TaxYear eq %d', [FTaxYear]);
  end;

  if lClaimFilter = '' then
    Result := AFilter
  else if Trim(AFilter) = '' then
    Result := lClaimFilter
  else
    Result := lClaimFilter + ' and (' + AFilter + ')';
end;

procedure TClaimScopedListForm.ClaimViewCloseClick(Sender: TObject);
begin
  ModalResult := mrOK;
end;

procedure TClaimScopedListForm.SetClaimContext(AClaimId, ATaxYear: Integer;
  const AClaimStatus: string);
begin
  FClaimId := AClaimId;
  FTaxYear := ATaxYear;
  FClaimStatus := AClaimStatus;
end;

procedure TClaimScopedListForm.ApplyClaimContextUI;
begin
  if FClaimId <= 0 then
    Exit;

  if not Assigned(AddButton) or not Assigned(MainDataset) or not Assigned(DataTable) then
    Exit;

  AddButton.Visible := True;
  AddButton.Enabled := True;
  AddButton.Caption := 'Close';
  AddButton.OnClick := ClaimViewCloseClick;
  {$IFDEF PAS2JS}
  asm
    var closeBtn = document.getElementById('CloseThisButton');
    if (closeBtn) {
      closeBtn.style.display = 'none';
    }
    var addBtn = document.getElementById('AddButton') || document.getElementById('AddButtonGASDS');
    if (addBtn) {
      addBtn.textContent = 'Close';
      addBtn.setAttribute('aria-label', 'Close');
    }
    var statusLbl = document.getElementById('Status');
    if (statusLbl) {
      statusLbl.style.display = 'none';
    }
    var filterCombo = document.getElementById('FilterCombo');
    if (filterCombo) {
      filterCombo.style.display = 'none';
    }
  end;
  {$ENDIF}
end;

end.
